import React, { useState, useEffect, useContext } from 'react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import ManageCabs from '../Screens/ManageCabs'
import ManageDriver from '../Screens/ManageDriver'
import AddCab from '../Screens/ManageCabs/AddCab'
import Header from '../Components/Header'
import Sidebar from '../Components/Sidebar.js/Sidebar'
import CabBookingReport from '../Screens/CabBookingReport'
import Transaction from '../Screens/Transaction'
import RegFletDriver from '../Screens/RegFletDriver'
import SignIn from '../Screens/SignIn'
import { MyContext } from '../utils/context/TempAuth'
import CabBookingHistory from '../Screens/CabBookingHistory'
import SearchCabBooking from '../Screens/CabBookingHistory/CabBookingHistory'
import AddDriver from '../Screens/ManageDriver/popup/AddDriver'
import FleetDriverEdit from '../Screens/ManageDriver/popup/FleetDriverEdit'
import FleetCabEdit from '../Screens/ManageCabs/popup/FleetCabEdit'

const Routing = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isvalid, setIsvalid] = useState(false)
  const { auth } = useContext(MyContext)

  const toggleDrawer = () => {
    setIsDrawerOpen((prevState) => !prevState)
  }

  useEffect(() => {
    setIsvalid(auth?.checkValidity())
  }, [auth])

  return (
    <div>
      <React.Fragment>
        <div className="">
          {isvalid ? (
            <React.Fragment>
              <>
                <Header toggleDrawer={toggleDrawer} />
                <Sidebar
                  isDrawerOpen={isDrawerOpen}
                  toggleDrawer={toggleDrawer}
                />
              </>
              <div className={`lg:ml-64 p-4`}>
                <div className="mt-20">
                  <Routes>
                    <Route path="/manage-cabs" element={<ManageCabs />} />
                    <Route path="/manage-cabs/add-cab" element={<AddCab />} />
                    <Route path="/manage-driver" element={<ManageDriver />} />
                    <Route
                      path="/manage-driver/add-driver"
                      element={<AddDriver />}
                    />
                    <Route
                      path="/manage-driver/edit-driver"
                      element={<FleetDriverEdit />}
                    />
                    <Route
                      path="/manage-cab/edit-cab"
                      element={<FleetCabEdit />}
                    />
                    <Route
                      path="/cab-booking-report"
                      element={<CabBookingReport />}
                    />
                    <Route path="/" element={<CabBookingReport />} />
                    <Route path="/transaction" element={<Transaction />} />
                    <Route
                      path="/booking-history"
                      element={<CabBookingHistory />}
                    />
                    <Route
                      path="/search-cab-booking"
                      element={<SearchCabBooking />}
                    />
                  </Routes>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className={`lg:ml-64 p-4`}>
                <Routes>
                  <Route path="/signin" element={<SignIn />} />
                  <Route path="/" element={<SignIn />} />
                  <Route
                    path="/register-flet-owner"
                    element={<RegFletDriver />}
                  />
                </Routes>
              </div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    </div>
  )
}

export default Routing
